<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">What is your occupation?</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3"></div>
            <div class="col-md-6">
                <b-form-group :state="stateForField('search')" :invalid-feedback="errorForField('search')">
                    <b-input-group>
                        <b-form-input autofocus autocomplete="off" autocapitalize="none" autocorrect="off" size="lg" :state="stateForField('search')" v-model="searchTerm"></b-form-input>
                        <b-input-group-append>
                            <b-button @click.prevent="performSearch" variant="primary"><font-awesome-icon icon="search"/></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3"></div>
            <div class="col-md-6">
                <div class="d-flex flex-wrap align-items-start justify-content-center">
                    <div v-if="searchTerm" @click.prevent="selectOtherOccupation(searchTerm)" class="result">
                        <h1 class="text-center">{{ searchTerm }}</h1>
                    </div>
                    <div @click.prevent="selectOccupation(occupation)" v-for="(occupation,index) in searchResults" :key="index" class="result">
                        <h1 class="text-center">{{ occupation.name }}</h1>
                    </div>
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div v-if="!hasChanged" class="row">
            <div class="col text-center mt-2">
                <button type="button" @click.prevent="next()" class="btn btn-primary btn-lg mx-auto mt-2" style="width: 40%"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
            </div>
        </div>

    </div>
</template>

<script>
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import OptionsMixin from '../../mixins/OptionsMixin'
  import { BButton, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
  import _ from 'lodash'

  export default {
    name: 'Occupation',

    components: { BButton, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend },

    mixins: [ErrorsMixin, OptionsMixin],

    data () {
      return {
        employment: {
          occupationId: 0,
          occupationOther: null
        },
        searchResults: {},
        searchTerm: '',
        pauseSearch: false,
        hasChanged: false,
        isSaving: false
      }
    },

    watch: {
      searchTerm (newValue, oldValue) {
        if (this.pauseSearch === false && newValue !== oldValue) {
          this.hasChanged = true
          this.debounceSearch()
        }
      }
    },

    computed: {
    },

    methods: {
      validate () {
        this.clearAllErrors()

        return !this.hasErrors()
      },

      loadData () {
        api.get('/Patient/Employment').then(response => {
          this.employment = response.data
          this.pauseSearch = true
          if (this.employment.occupation && this.employment.occupation.name) {
            this.searchTerm = this.employment.occupation.name
          } else if (this.employment.occupationOther) {
            this.searchTerm = this.employment.occupationOther
          }
          this.$nextTick(() => {
            this.pauseSearch = false
          })
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error searching loading employment: ' + error.message, error)
          }
        })
      },

      debounceSearch: _.debounce(function () { this.performSearch() }, 800),

      performSearch () {
        if (this.pauseSearch === true || !this.searchTerm || this.searchTerm.length < 2) {
          return
        }

        this.hasChanged = true
        api.get('/Patient/OccupationSearch?query=' + this.searchTerm).then(response => {
          this.searchResults = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error searching for occupation: ' + error.message, error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else if (error.message) {
              this.addErrorForField('exception', error.message)
            }
          }
        })
      },

      selectOccupation (occupation) {
        if (this.hasChanged === true) {
          this.employment.occupationId = occupation.occupationId
          this.employment.occupationOther = null
        }
        this.saveOccupation()
      },

      selectOtherOccupation (occupationName) {
        if (this.hasChanged === true) {
          this.employment.occupationId = null
          this.employment.occupationOther = occupationName
        }
        this.saveOccupation()
      },

      next () {
        this.isSaving = true
        if (this.employment.employmentId === 5) {
          this.$store.setModuleStatus('Employment', true, () => {
            this.isSaving = false
            this.$router.push(this.$store.nextRoute())
          })
        } else {
          this.isSaving = false
          this.$router.push('/employer')
        }
      },

      saveOccupation () {
        this.isSaving = true

        api.put('/Patient/Employment', this.employment).then(response => {
          // patient is self employed
          this.next()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error saving employment: ' + error.message, error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else if (error.message) {
              this.addErrorForField('exception', error.message)
            }
          }
        }).then(() => {
          this.isSaving = false
        })
      }

    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

    .result {
        box-shadow: 2px 2px 5px darkgray;
        margin: .25em;
        border-radius: 5px;
        background-color: white;
        width: 100%;
        border: 2px solid transparent;
    }

    .result h1 {
        font-size: 24px;
        color: rgba(23,56,96,1.0);
        font-weight: bold;
        padding: .25em;
    }
    @media (min-width: 1061px) {
        .result:HOVER {
            cursor: pointer;
            border: 2px solid rgba(255,62,3,1.0);
        }
    }
</style>
